import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import Animate from '../../../components/Animate';
import ViewAttachmentPopup from '../../../components/ViewAttachmentPopup';
import FileUtil from '../../../helpers/FileUtil/FileUtil';
import ComboBox from '../../../components/ComboBox';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import expandor from '../../../assets/images/expandor.svg';
import contractor from '../../../assets/images/contractor.svg';
import trashIcon from '../../../assets/images/trash.svg';
import dataModel from '../../../models/DataModel';
import { task_root, project_template_task_root } from '../../../dao/TasksDAO';
import { project_template_root } from '../../../dao/ProjectTemplatesDAO';

import './ReferenceDocs.scss';

export class ReferenceDocs extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { expanded: true, pendingDocumentUpdates: 0 };

    //init analytics
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.handleMultipleSelection = this.handleMultipleSelection.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    const { task, projectTemplate } = this.props;
    if (task){
      this.setState({ task });
      dataModel.actionCableConnector.registerCallback(this.handleActionCable, ['updateTask'], [this.props.task.id], this.props.project ? task_root : project_template_task_root);
    }
    if (task) {
      this.setState({ editReferenceDocuments: task.reference_documents ? task.reference_documents.map(rd => { return rd; }) : [] });
    }
    else if (projectTemplate) {
      this.setState({ editReferenceDocuments: projectTemplate.reference_documents ? projectTemplate.reference_documents.map(rd => { return rd; }) : [] });
    }
    this.props.referenceDocumentsDataModel.fetchReferenceDocuments('', '', '', {}, '', false, null, null, null, true);
  }

  async handleActionCable(fetchedData, acData) {
    if (fetchedData) {
      this.setState({ task: fetchedData, editReferenceDocuments: fetchedData.reference_documents });
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.props.task) {
      dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['updateTask'], [this.props.task.id]);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.task != this.props.task) {
      this.setState({
        task: this.props.task,
        editReferenceDocuments: this.props.task.reference_documents
          ? this.state.task.reference_documents.map(rd => {
            return rd;
          })
          : [],
      });
      if (!this.oldExpandedHeight || this.oldExpandedHeight != this.expandedHeight) {
        this.setState({ animateExpand: true });
      }
    }
    else if (prevProps.projectTemplate != this.props.projectTemplate) {
      this.setState({
        editReferenceDocuments: this.props.projectTemplate.reference_documents
          ? this.props.projectTemplate.reference_documents.map(rd => {
            return rd;
          })
          : [],
      });
      if (!this.oldExpandedHeight || this.oldExpandedHeight != this.expandedHeight) {
        this.setState({ animateExpand: true });
      }
    }
    if(this.props.updateReferenceDocument && (this.props.updatedReferenceDocuments != this.state.editReferenceDocuments)){
      this.props.updateReferenceDocument(this.state.editReferenceDocuments);
    }
  }

  doDeleteDocument(dataIdStr) {
    const { editReferenceDocuments } = this.state;
    if (dataIdStr) {
      const dataId = parseInt(dataIdStr, 10);
      const docToDelete = editReferenceDocuments.find(reference_document => {
        return reference_document.id == parseInt(dataId, 10);
      });

      if (docToDelete) {
        const indexToDelete = editReferenceDocuments.findIndex(doc => doc.id == docToDelete.id);
        editReferenceDocuments.splice(indexToDelete, 1);
        this.setState({ editReferenceDocuments });
        if (this.state.task) {
          dataModel.dataChanged = true;
          this.props.updateEditFlag && this.props.updateEditFlag(true);
        }
        else if (this.props.projectTemplate) {
          dataModel.projectTemplatesDAO.removeReferenceDocument(docToDelete.id, this.props.projectTemplate.id, null, { recordDescriptor: project_template_root })
            .catch(error => {
              // undo the delete
              editReferenceDocuments.splice(indexToDelete, 0, docToDelete);
              this.setState({ editReferenceDocuments });
            });
        }
      }
    }
  }

  handleRemoveDocument(e) {
    const message = 'Are you sure you want to delete this Reference Document?';

    const dataIdStr = e.target.getAttribute('data-id');

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.no.toUpperCase(), 
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300, 
      height: 175, 
      handleOwnerOk: () => {
        this.doDeleteDocument(dataIdStr);
      }, 
      handleOwnerCancel: () => {
        this.customSetting = null;
      },
    });
  }

  handleCloseAttachmentPopup() {
    this.setState({ reference_documentPopup: null });
  }

  handleViewDocument(e) {
    const dataIdStr = e.target.getAttribute('data-id');
    if (dataIdStr) {
      const reference_documents = this.state.task ? this.state.task.reference_documents : this.props.projectTemplate.reference_documents;
      let dataId = parseInt(dataIdStr, 10);
      const matchedAttachment = reference_documents.filter(reference_document => {
        return reference_document.id == parseInt(dataId, 10);
      });

      if (matchedAttachment.length > 0) {
        const width = window.innerWidth - 300;
        const height = window.innerHeight - 190;
        const imageWidth = width;
        const imageHeight = height - 60;
        let reference_documentPopup = (
          <ViewAttachmentPopup 
            attachment={matchedAttachment[0]} 
            handlePopupClose={this.handleCloseAttachmentPopup} 
            left={100} 
            top={100}
            width={width} 
            height={height} 
            imageWidth={imageWidth} 
            imageHeight={imageHeight}
          />
        );

        this.setState({ reference_documentPopup: reference_documentPopup });
        //log image download
        const extension = FileUtil.getExtension(matchedAttachment[0].name);
        this.analyticsLogger.logRDLDownloadEvent(extension);
      }
    }
  }

  createReferenceDocsList(ignoreAdded) {
    const { editReferenceDocuments } = this.state;
    this.expandedHeight = 84;

    let referenceDocsList = null;
    if (editReferenceDocuments) {
      referenceDocsList = editReferenceDocuments.map(reference_document => {
        this.expandedHeight += 40;
        let remove = null;
        if (this.props.editing) {
          remove = <img className="remove-button" src={trashIcon} data-id={reference_document.id} onClick={this.handleRemoveDocument} alt="remove-button" />;
        }
        return (
          <div className="reference-doc-row" key={'ref-doc-' + reference_document.id}>
            <div className="document-name" data-id={reference_document.id} onClick={this.handleViewDocument}>{reference_document.name.toUpperCase()}</div>
            {remove}
          </div>
        );
      });
    }
    return <div className="reference-docs-list">
        {referenceDocsList}
      </div>;
  }

  handleMultipleSelection(multipleSelections, selectedOption) {
    const selectedDocument = selectedOption.referenceDocument;
    if (selectedDocument) {
      let documents = this.state.editReferenceDocuments.map(rd => { return rd; });
      if (selectedOption.selected) {
        const findDocument = documents && documents.length ? documents.filter(document => {
          return document.id == selectedDocument.id;
        }) : [];
        if (findDocument.length == 0) {
          selectedDocument.toBeAdded = true;
          documents.push(selectedDocument);
        }
        else {
          delete findDocument[0].toBeDeleted;
        }
      }
      else {
        let removeIndex = -1;
        const findDocument = documents ? documents.filter((document, index) => {
          if (selectedDocument.id == document.id && document.toBeAdded) {
            removeIndex = index;
          }
          return selectedDocument.id == document.id;
        }) : [];
        if (removeIndex >= 0) {
          documents.splice(removeIndex, 1);
        }
        else {
          if (findDocument.length == 0) {
            selectedDocument.toBeDeleted = true;
            documents.push(selectedDocument);
          }
          else {
            findDocument[0].toBeDeleted = true;
          }
        }
      }
      dataModel.dataChanged = true;
      this.props.updateEditFlag && this.props.updateEditFlag(true);
      this.setState({ editReferenceDocuments: documents });
    }
  }

  createMenuOptions() {
    const { referenceDocuments, currentCompany } = this.props;
    const { editReferenceDocuments } = this.state;
    const referenceDocOptions = referenceDocuments ? referenceDocuments.filter((referenceDocument) => { return referenceDocument.company_id == currentCompany.id; }).map(
          referenceDocument => {
            const selected = editReferenceDocuments
              ? editReferenceDocuments.filter(rd => {
                return rd.id == referenceDocument.id && !rd.toBeDeleted;
              })
              : [];
            return {
              type: referenceDocument.id,
              name: referenceDocument.name,
              selected: selected.length > 0,
              referenceDocument: referenceDocument,
            };
          }
        ) : [];
    return referenceDocOptions.filter(entry => {
      return entry.type;
    });
  }

  // The add/remove requests only fire once the picker closes, and the resulting document list
  // is rendered from the store, so without this counter there is no feedback at all while the
  // requests are in flight.
  trackPendingDocumentUpdates(requests) {
    const pendingRequests = requests.filter(request => request && typeof request.then == 'function');
    if (!pendingRequests.length) {
      return;
    }
    this.setState(prevState => {
      return { pendingDocumentUpdates: (prevState.pendingDocumentUpdates || 0) + pendingRequests.length };
    });
    pendingRequests.forEach(request => {
      const clearPendingRequest = () => {
        if (this.unmounted) {
          return;
        }
        this.setState(prevState => {
          return { pendingDocumentUpdates: Math.max(0, (prevState.pendingDocumentUpdates || 0) - 1) };
        });
      };
      request.then(clearPendingRequest, clearPendingRequest);
    });
  }

  handleUpdateReferenceDocs() {
    const editReferenceDocuments = [...this.state.editReferenceDocuments];
    const finalReferenceDocuments = [];
    const pendingRequests = [];
    editReferenceDocuments.forEach(referenceDoc => {
      if (referenceDoc.toBeAdded) {
        finalReferenceDocuments.push(referenceDoc);
        if (!this.state.task){
          pendingRequests.push(dataModel.projectTemplatesDAO.addReferenceDocument(referenceDoc.id, this.props.projectTemplate.id, referenceDoc, { recordDescriptor: project_template_root }).then((response) => {
            delete referenceDoc.toBeAdded;
          }));
        }
      }
      else if (referenceDoc.toBeDeleted) {
        delete referenceDoc.toBeDeleted;
        if (this.state.task){
          pendingRequests.push(dataModel.tasksDAO.removeReferenceDocument(referenceDoc.id, this.state.task.id, null, { recordDescriptor: this.props.project ? task_root : project_template_task_root }).then((response) => {
            if (response.error) {
              const { editReferenceDocuments } = this.state;
              editReferenceDocuments.push(referenceDoc);
              this.setState({ editReferenceDocuments });
              return dataModel.tasksDAO.addReferenceDocument(referenceDoc.id, this.state.task.id, referenceDoc, { recordDescriptor: this.props.project ? task_root : project_template_task_root });
            }
          }).catch((error) => {
            const { editReferenceDocuments } = this.state;
            editReferenceDocuments.push(referenceDoc);
            this.setState({ editReferenceDocuments });
            return dataModel.tasksDAO.addReferenceDocument(referenceDoc.id, this.state.task.id, referenceDoc, { recordDescriptor: this.props.project ? task_root : project_template_task_root });
          }));
        }
        else {
          pendingRequests.push(dataModel.projectTemplatesDAO.removeReferenceDocument(referenceDoc.id, this.props.projectTemplate.id, null, { recordDescriptor: project_template_root }).then((response) => {
            if (response.error) {
              const { editReferenceDocuments } = this.state;
              editReferenceDocuments.push(referenceDoc);
              this.setState({ editReferenceDocuments });
              return dataModel.projectTemplatesDAO.addReferenceDocument(referenceDoc.id, this.props.projectTemplate.id, referenceDoc, { recordDescriptor: project_template_root });
            }
          }).catch((error) => {
            const { editReferenceDocuments } = this.state;
            editReferenceDocuments.push(referenceDoc);
            this.setState({ editReferenceDocuments });
            return dataModel.projectTemplatesDAO.addReferenceDocument(referenceDoc.id, this.props.projectTemplate.id, referenceDoc, { recordDescriptor: project_template_root });
          }));
        }
      } else {
        finalReferenceDocuments.push(referenceDoc);
      }
    });

    this.setState({
      editReferenceDocuments: finalReferenceDocuments });
    this.trackPendingDocumentUpdates(pendingRequests);
  }

  handleFinishAnimation() {
    if (this.state.animateContract) {
      this.oldExpandedHeight = null;
      this.setState({
        animateContract: false,
        expanded: false,
      });
    }
    else {
      this.oldExpandedHeight = this.expandedHeight;
      this.setState({
        animateExpand: false,
        expanded: true,
      });
    }
  }
  
  handleExpandor() {
    if (!this.state.expanded) {
      this.setState({ animateExpand: true });
    } else {
      this.setState({ animateContract: true });
    }
  }

  render() {
    const referenceDocOptions = this.createMenuOptions();

    const updatingDocuments = this.state.pendingDocumentUpdates > 0;

    const icon = this.state.expanded ? contractor : expandor;

    let animate = null;

    if (this.state.animateExpand && this.expandedHeight) {
      animate = <Animate component_id="reference-docs" key="animate-expand" property={{ height: { startVal: this.oldExpandedHeight ? this.oldExpandedHeight : 24, endVal: this.expandedHeight } }} completionCallback={this.handleFinishAnimation}
        duration={250}/>;
    }
    else if (this.state.animateContract && this.expandedHeight) {
      animate = <Animate component_id="reference-docs" key="animate-contract" property={{ height: { startVal: this.expandedHeight, endVal: 24 } }} completionCallback={this.handleFinishAnimation}
        duration={250}/>;
    }
    const referenceDocs = this.state.task ? this.createReferenceDocsList(!animate) : null;

    let addReferenceDocs;
    if (this.props.editing) {
      addReferenceDocs = (
        <div className="entry-field">
          <div className="label">SELECT DOCUMENTS</div>
          <div id="reference-document-picker-container" className={'field combo'}>
            <ComboBox
              id={'reference-document-picker'}
              options={referenceDocOptions}
              hasBorder={false}
              underlined={false}
              width={this.state.task ? 358 : 230} small={true} showSearchBar={true}
              height={24} displayFontStyle={{ fontSize: '12px' }}
              handleMultiMenuSelection={this.handleMultipleSelection} multiSelect={true}
              noFocus={true}
              handleCloseComboBox={this.handleUpdateReferenceDocs}
              searchHint={'Search Documents'}
              loading={updatingDocuments}
            />
          </div>
        </div>
      );
    }

    return (

      // Replace with the appropriate HTML
      <div className="reference-docs" id="reference-docs">
        {this.state.reference_documentPopup}
        {animate}
        <div className='detail-section'>
          {this.state.task && <div className="section-header">
            <div className="section-caption">REFERENCE DOCUMENTS</div>
            <img className="section-icon" src={icon} alt="Docs" onClick={this.handleExpandor} />
          </div>}
          {referenceDocs}
          {addReferenceDocs}
        </div>
      </div>  
    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    dataModel: dataModel,
    referenceDocumentsDataModel: dataModel.referenceDocumentsDataModel,
    referenceDocuments: state.referenceDocuments.referenceDocuments,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(ReferenceDocs);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/ReferenceDocs/index.js